import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { TableCell, TableRow } from "@/components/ui/table";
import { PaginatedBusinessIncome } from "@/components/v2/organisms/admin/tabs/BusinessIncomeTab/BusinessIncomeTable";
import { formatCurrency } from "@/utils/shared/currencyUtils";
import { formatFullNumericDateUTC } from "@/utils/shared/dateUtils";
import { Edit, Trash2 } from "lucide-react";

interface BusinessIncomeRowProps {
  income: PaginatedBusinessIncome;
  index: number;
  onEdit: (income: PaginatedBusinessIncome) => void;
  onDelete: (income: PaginatedBusinessIncome) => void;
  canEdit?: boolean;
  canDelete?: boolean;
  isSelected: boolean;
  onSelect: (incomeId: string, index: number, shiftKey: boolean, income: PaginatedBusinessIncome) => void;
}

const BusinessIncomeRow = ({
  income,
  index,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  isSelected,
  onSelect,
}: BusinessIncomeRowProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "Pagado":
        return "bg-green-100 hover:bg-green-200 text-green-800";
      case "Pendiente":
        return "bg-yellow-100 hover:bg-yellow-200 text-yellow-800";
      case "Cancelado":
        return "bg-red-100 hover:bg-red-200 text-red-800";
      default:
        return "bg-gray-100 hover:bg-gray-200 text-gray-800";
    }
  };

  return (
    <TableRow>
      <TableCell onClick={(e) => onSelect(income.id, index, e.shiftKey, income)}>
        <Checkbox
          checked={isSelected}
          onCheckedChange={() => {}}
          aria-label="Seleccionar ingreso"
        />
      </TableCell>

      <TableCell>{income.organization_name || "Sin organización"}</TableCell>

      <TableCell>{income.property_short_name || "-"}</TableCell>

      <TableCell>{income.income_type}</TableCell>

      <TableCell>{income.payment_type}</TableCell>

      <TableCell>
        {income.gross_payment ? formatCurrency(income.gross_payment) : "-"}
      </TableCell>

      <TableCell>{income.iva ? formatCurrency(income.iva) : "-"}</TableCell>

      <TableCell>{formatCurrency(income.total_payment)}</TableCell>

      <TableCell>{income.description || "-"}</TableCell>

      <TableCell>
        <Badge className={getStatusColor(income.payment_status)}>
          {income.payment_status}
        </Badge>
      </TableCell>

      <TableCell>{formatFullNumericDateUTC(income.payment_date)}</TableCell>

      {(canEdit || canDelete) && (
        <TableCell className="flex items-center space-x-2">
          {canEdit && (
            <Button variant="outline" size="sm" onClick={() => onEdit(income)}>
              <Edit className="h-4 w-4" />
            </Button>
          )}

          {canDelete && (
            <Button
              variant="destructive"
              size="sm"
              onClick={() => onDelete(income)}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </TableCell>
      )}
    </TableRow>
  );
};

export default BusinessIncomeRow;
